<template>
  <div class="calendar-container">
    <div class="calendar-month-control">
      <div class="prev icon">
        <button type="button" class="btn btn-action" @click.stop="onPrevMonth(selectedDate)">
          <i class="fas fa-angle-left"></i>
        </button>
      </div>
      <div class="month">{{formatMonth(selectedDate)}}</div>
      <div class="next icon">
        <button type="button" class="btn btn-action" @click.stop="onNextMonth(selectedDate)">
          <i class="fas fa-angle-right"></i>
        </button>
      </div>
    </div>
    <div class="calendar-header-container">
      <div class="calendar-item"
        v-for="(day, dayIndex) in dayOfWeek"
        :key="dayIndex">
        {{day}}
      </div>
    </div>
    <div class="calendar-item-container">
      <router-link
        :to="generateScheduleDateLink(item)"
        v-for="(item, itemIndex) in dayList"
        :key="itemIndex"
        class="calendar-item">
        {{getDate(item)}} <i class="fas fa-circle icon" :class="generateScheduleIcon(item)"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import dateFormatter from '@/utils/dateFormatter';
import scheduleManagement from '@/utils/scheduleManagement';

import { loadSchedulesMonthly } from './api';

export default {
  mixins: [dateFormatter, scheduleManagement],
  props: {
    scheduleDate: {
      type: String,
    },
  },
  computed: {
    scheduleYear() {
      return this.$route.params.scheduleYear;
    },
    scheduleMonth() {
      return this.$route.params.scheduleMonth;
    },
  },
  data() {
    return {
      scheduleMonthly: [],
      dayList: [],
      selectedDate: null,
      dayOfWeek: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    };
  },
  watch: {
    scheduleDate(newValue) {
      this.load(newValue);
    },
    selectedDate(newValue) {
      const { scheduleYear, scheduleMonth } = this.transformDateToParams(newValue);
      this.loadScheduleMonthly(scheduleYear, scheduleMonth);
    },
  },
  created() {
    this.load(this.scheduleDate);
  },
  methods: {
    load(selectedDate) {
      this.selectedDate = _.cloneDeep(selectedDate);
      this.dayList = this.generateDayOfCalendarMonth(this.selectedDate);
    },
    onNextMonth(selectedDate) {
      this.selectedDate = this.getNextMonth(selectedDate);
      this.dayList = this.generateDayOfCalendarMonth(this.selectedDate);
    },
    onPrevMonth(selectedDate) {
      this.selectedDate = this.getPrevMonth(selectedDate);
      this.dayList = this.generateDayOfCalendarMonth(this.selectedDate);
    },
    async loadScheduleMonthly(scheduleYear, scheduleMonth) {
      const reponse = await loadSchedulesMonthly(scheduleYear, scheduleMonth);
      this.scheduleMonthly = reponse.data;
    },
    isScheduleCreated(item) {
      // find from scheduleMonthly Array
      return _.find(this.scheduleMonthly.dailySchedules,
        (dailySchedule) => this.isSameDay(dailySchedule.date, item));
    },
    generateScheduleIcon(item) {
      const isCreated = this.isScheduleCreated(item);
      if (isCreated) {
        return 'text-success';
      }
      return '';
    },
    generateScheduleDateLink(date) {
      const scheduleDate = this.formatScheduleDate(date);
      return `/schedules/${scheduleDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.calendar-container {
  background-color: white;

  .calendar-month-control {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: $spacer * 0.75;

    .month {
      font-size: $font-size-base * 1.25;
    }
  }


  .calendar-header-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -12px;

    .calendar-item {
      height: 32px;
      font-size: $font-size-base * 0.875;
    }
  }

  .calendar-item-container {
    display: flex;
    flex-wrap: wrap;
  }

  .calendar-item {
    flex: 0 0 calc(100% / 7);
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    color: $gray-700;

    .icon {
      position: absolute;
      bottom: 10px;
      font-size: $font-size-sm * 0.5;
      color: $gray-500;
    }
  }

}
</style>
